import React from 'react';
import { Card, Typography, Button } from 'antd';
import { PlusCircleFilled } from '@ant-design/icons';

import CharacterCard from './CharacterCard';

const { Title } = Typography;

const CharacterSection = ({
  selectedCharacters = [],
  handleCharacterInputChange,
  handleColorChange,
  handleCharacterImageChange,
  handleRemoveCharacter,
  handleAddCharacter,
  COLOR_OPTIONS,
  getBrightness,
  requestCharacterDelete,
  actors = [],
}) => {

  console.log("characters:>>::", selectedCharacters);

  return (
    <Card className="editorContainer" bordered>
      <Title level={4}>Charakterübersicht TEST</Title>

      <div className="characters">
        {selectedCharacters.map((character, index) => (
          <CharacterCard
          key={character.localId || index}
          character={character}
          index={index}
          handleCharacterInputChange={handleCharacterInputChange}
          handleColorChange={handleColorChange}
          handleCharacterImageChange={handleCharacterImageChange}
          handleRemoveCharacter={handleRemoveCharacter}
          COLOR_OPTIONS={COLOR_OPTIONS}
          getBrightness={getBrightness}
          requestCharacterDelete={requestCharacterDelete} 
          actors={actors}
          />
        ))}

        <Button
          icon={<PlusCircleFilled style={{ fontSize: '24px' }} />}
          className="writeButton"
          onClick={handleAddCharacter}
          type="primary"
        >
          Charakter hinzufügen
        </Button>
      </div>
    </Card>
  );
};

export default CharacterSection;